import React from "react";

const Info = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx={12}
        cy={12}
        r={11}
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 11h2v6M10 17h4"
      />
      <circle fill="currentColor" fillRule="nonzero" cx={12} cy={7} r={1} />
    </g>
  </svg>
);

export default Info;



// WEBPACK FOOTER //
// ./src/theme/icons/Info.js